import { render, staticRenderFns } from "./VideoIcon.vue?vue&type=template&id=07e15a46&scoped=true"
import script from "./VideoIcon.vue?vue&type=script&lang=js"
export * from "./VideoIcon.vue?vue&type=script&lang=js"
import style0 from "./VideoIcon.vue?vue&type=style&index=0&id=07e15a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e15a46",
  null
  
)

export default component.exports